import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UserHal} from '../../models/HAL/user-hal.model';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {NgClass} from '@angular/common';
import {AdditionalUserInfo} from '../smart-text/additional-user-info.component';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-user-card',
  imports: [
    MatIconButton,
    MatIcon,
    NgClass,
    AdditionalUserInfo,
    TranslatePipe
  ],
  templateUrl: './user-card.component.html',
  styleUrl: './user-card.component.scss'
})
export class UserCardComponent {
  @Input() user: UserHal | null = null;
  @Input() selected = false;

  @Output() userDeselected = new EventEmitter<void>();

  getUserInitials(user: UserHal | null): string {
    if (user) {
      const firstNameInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : '';
      const lastNameInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : '';
      return `${firstNameInitial}${lastNameInitial}`;
    }
    return '';
  }

  deselectUser() {
    this.userDeselected.emit();
  }
}
